import { addYears } from 'date-fns';
export const getEntitlementYearOverlapMessage = (startDate, endDate, userSettingsState) => {
    const currentDate = new Date();
    const pastAndUpcoming = startDate < currentDate && endDate > currentDate;
    const endOfCurrentHolidayYear = new Date(userSettingsState.end);
    const endOfLastHolidayYear = addYears(endOfCurrentHolidayYear, -1);
    const pastAndCurrentHolidayYearsOverlap = startDate < endOfLastHolidayYear && endDate > endOfLastHolidayYear;
    const currentAndFutureHolidayYearsOverlap = startDate < endOfCurrentHolidayYear && endDate > endOfCurrentHolidayYear;
    if (pastAndUpcoming) {
        return 'Please split this absence into past and upcoming.';
    }
    if (pastAndCurrentHolidayYearsOverlap) {
        return 'Please split this absence into previous and current holiday years.';
    }
    if (currentAndFutureHolidayYearsOverlap) {
        return 'Please split this absence into current and future holiday years.';
    }
    return '';
};
export const getPastDateSelectedWithApprovalRequiredMessage = (startDate, endDate, userSettingsState, approvalRequired) => {
    const isInPast = (endDate ?? startDate) < new Date();
    const isInCurrentEntitlementYear = new Date(userSettingsState.end);
    if (isInPast && isInCurrentEntitlementYear && approvalRequired) {
        return 'To send an approval request, your absence must occur in the future';
    }
    return '';
};
export const isFutureDateInCurrentEntitlementYear = (startDate, endDate, userSettingsState) => {
    const isInFuture = (endDate ?? startDate) > new Date();
    const isInCurrentEntitlementYear = new Date(userSettingsState.end);
    return isInFuture && isInCurrentEntitlementYear;
};
